import { render, staticRenderFns } from "./keyBorrowReturn.vue?vue&type=template&id=b640c51a"
import script from "./keyBorrowReturn.vue?vue&type=script&lang=js"
export * from "./keyBorrowReturn.vue?vue&type=script&lang=js"
import style0 from "./keyBorrowReturn.vue?vue&type=style&index=0&id=b640c51a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports